import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import {
  UserContextConsumer,
  UserContextState,
} from '../../../../../contexts/UserContext';
import {
  CreateUserQuery,
  LoginQuery,
  LoginWithFbQuery,
} from '../../../../../infrastructure/repositories/AuthRepository';
import * as IPurchases from '../../../../../interfaces/merchants/products/purchases';
import * as IInputs from '../../../../../interfaces/merchants/products/purchases/inputs';
import {
  setMeToPurchaseInfo,
  setPostable,
} from '../../../../../redux/actions/merchants/products/purchases';
import * as aUser from '../../../../../redux/actions/users/api';
import { Dispatch } from '../../../../../redux/reducers/merchants/products/purchases/inputs';
import PurchaseCreateUserAlert from '../common/texts/PurchaseCreateUserAlert';
import PurchaseLoginRequireAlert from '../common/texts/PurchaseLoginRequireAlert';
import InputCreateUser from './createUser';
import InputLogin from './login';

interface ElementProps {
  schemeType: IPurchases.SchemeType;
  postable: boolean;
  onSubmit: () => void;
  onSubmitSubscribed?: () => void;
}

interface StateProps {
  inputs: IInputs.State;
}

interface DispatchProps {
  actions: {
    handleSetMe: (productId: string) => Promise<void>;
    handlePostable: (postable: boolean) => void;
  };
}

enum ViewType {
  Login = 'login',
  CreateUser = 'createUser',
}

type Props = ElementProps & StateProps & DispatchProps & InjectedIntlProps;

interface State {
  viewType: ViewType;
}

class InputRequireLogin extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogined = this.handleLogined.bind(this);
    this.handleCreateUser = this.handleCreateUser.bind(this);
    this.handleSwitchView = this.handleSwitchView.bind(this);
    this.state = {
      viewType: ViewType.Login,
    };
  }

  private handleSwitchView(viewType: ViewType) {
    this.setState({ viewType });
  }

  private async handleLogined() {
    const {
      schemeType,
      inputs,
      actions,
      onSubmit,
      onSubmitSubscribed,
    } = this.props;
    await actions.handleSetMe(inputs.productId!);
    if (schemeType === IPurchases.SchemeType.Subscription) {
      const userSubscription = await aUser.fetchUsersSubscription(
        inputs.productId!,
      );
      if (userSubscription && onSubmitSubscribed) {
        onSubmitSubscribed();
      } else {
        onSubmit();
      }
    }
    if (schemeType === IPurchases.SchemeType.TicketBook) {
      onSubmit();
    }
  }

  private async handleLogin(_q: LoginQuery, userCtx: UserContextState) {
    const { actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .login(_q.email, _q.password)
      .then(async _ => {
        this.handleLogined();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  private async handleLoginWithFb(
    query: LoginWithFbQuery,
    userCtx: UserContextState,
  ) {
    const { actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .loginWithFb(query)
      .then(async _ => {
        this.handleLogined();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  private async handleCreateUser(
    query: CreateUserQuery,
    userCtx: UserContextState,
  ) {
    const { actions } = this.props;
    actions.handlePostable(false);
    userCtx.auth
      .createUser(query)
      .then(async _ => {
        this.handleLogined();
        actions.handlePostable(true);
      })
      .catch((_err: Error) => {
        actions.handlePostable(true);
      });
  }

  public render() {
    const { viewType } = this.state;
    const { schemeType, postable } = this.props;
    const labelType =
      schemeType === IPurchases.SchemeType.Subscription
        ? 'subscription'
        : 'ticketBook';
    return (
      <UserContextConsumer>
        {context => (
          <>
            {viewType === ViewType.Login && (
              <>
                <PurchaseLoginRequireAlert
                  labelType={labelType}
                  onClick={() => this.handleSwitchView(ViewType.CreateUser)}
                />
                <InputLogin
                  postable={postable}
                  onLogin={(query: LoginQuery) =>
                    this.handleLogin(query, context)
                  }
                  onLoginWithFb={(query: LoginWithFbQuery) =>
                    this.handleLoginWithFb(query, context)
                  }
                  errors={context.auth.errors}
                />
              </>
            )}
            {viewType === ViewType.CreateUser && (
              <>
                <PurchaseCreateUserAlert
                  onClick={() => this.handleSwitchView(ViewType.Login)}
                />
                <InputCreateUser
                  postable={postable}
                  onSubmit={(query: CreateUserQuery) =>
                    this.handleCreateUser(query, context)
                  }
                  errors={context.auth.errors}
                />
              </>
            )}
          </>
        )}
      </UserContextConsumer>
    );
  }
}

const mapStateProps = ({
  merchantsProductsPurchasesInputs,
}: {
  merchantsProductsPurchasesInputs: IInputs.State;
}): StateProps => ({ inputs: merchantsProductsPurchasesInputs });

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: {
    handleSetMe: (productId: string) =>
      setMeToPurchaseInfo(productId)(dispatch),
    handlePostable: (postable: boolean) => setPostable(postable)(dispatch),
  },
});

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(injectIntl(InputRequireLogin));
